import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import App from './home/menu';  //for investor
import App from './home/menuAdvisor';  //for advisor
import reportWebVitals from './reportWebVitals';
// Import session manager to ensure interceptors are set up early
import { sessionManager, setupAxiosInterceptors } from './utils/sessionManager';
import axios from 'axios';
// depress console logs in production
 if (process.env.NODE_ENV === 'production') {
  console.log = function () {};
  console.debug = function () {};
  console.info = function () {};
}
 
console.log('Index.tsx - Current cookies:', document.cookie);
const authToken = getCookie('x-auth-token');
console.log('Index.tsx - Auth token from cookie:', authToken);

// Ensure axios interceptors are set up immediately
setupAxiosInterceptors(axios);
console.log('Index.tsx - Axios interceptors initialized');

// Note: Authorization header now handled by sessionManager interceptors
// axios.defaults.headers.common['Authorization'] = authToken ? 'Bearer ' + authToken : '';


function getCookie(cookieName: string): string | null {
  const nameEQ = cookieName + "=";
  const ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function setCookie(cookieName: string, cookieValue: string, expiryDays: number = 7) {
  const date = new Date();
  date.setTime(date.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
}

// Make setCookie available globally
(window as any).setCookie = setCookie;


ReactDOM.render(
    <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
